import { Link } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

import { media } from '~src/styles/media-templates';

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-around;
`;

export const SecondBtnLink = styled(Link)`
  margin-left: 30px;
  ${media.phone`
    margin-left: 15px;
  `}
`;

export const ErrorSubText = styled.div`
  font-size: 1rem;
`;

export const ErrorText = styled.div`
  font-size: 2rem;
`;

const spinning = keyframes`
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const SpinningGear = styled.div`
  animation: ${spinning} 3s linear infinite;
  margin-bottom: -10px;
  color: ${({ theme }) => theme.brandBlue.light};
`;

export const InfoText = styled.div`
  width: 100%;
`;

export const InfoTextNote = styled.div`
  width: 100%;
  font-size: 1rem;
`;
